module.exports = __webpack_public_path__ + "static/terranova-logotagline-screenshot-article-5dba120f29f300d5a5448cadce87cbab.png";